import React from 'react';

import { PRIVACY_URL, TERMS_URL } from 'pages/checkout/constants';

export const PrivacyLink = () =>
  <a target="_blank" rel="noreferrer" href={PRIVACY_URL}>Privacy Policy</a>;

export const TermsOfServiceLink = () =>
  <a target="_blank" rel="noreferrer" href={TERMS_URL}>Terms of Service</a>;
